



































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
// import SideTabRight from "@/components/SideTabRight.vue";
import requestService from "@/service/requestService";
import Number from "@/shared/filters/Number.ts";
import * as util from "@/service/util";
import { CouponData, CouponItem } from "@/model/Coupon";
import { Getter, Action } from "vuex-class";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import { UserService } from "@/service/UserService";
import UserFooter from "@/components/UserFooter.vue";
import { MESSAGE } from "@/model/Message";
import TopBarTitle from "@/components/common/TopBarTitle.vue";
import InputNumber from "@/components/common/input/InputNumber.vue";
@Component({
  filters: {
    Number
  },
  components: {
//    appSideTabRight: SideTabRight,
    ConfirmDialog,
    UserFooter,
    TopBarTitle,
    InputNumber
  }
})
export default class CouponPage extends Vue {
  isEditPrice: boolean = false;
  showAside: boolean = true;
  reqService: requestService;
  couponResult: any = 0;
  // couponData: CouponData = {
  //   coupon: {},
  //   proposal: {}
  // };
  subTotalZk: number = 0;
  subTotalZn: number = 0;

  updating: boolean = false;
  loadingText: string = MESSAGE.Loading;

  couponNm: string = "";
  couponZk: number | null = null;
  /** 2023-10-26 invoice [START] */
  couponZn: number | null = null;
  /** 2023-10-26 invoice [END] */

  $refs!: {
    // sideTab: SideTabRight;
    // confirmDialog: ConfirmDialog;
    errorDialog: ConfirmDialog;
    waitmd15Dialog: ConfirmDialog;
    inputKingaku: InputNumber[];
    exceedDialog: ConfirmDialog;
  };

  @Action("setCoupon", { namespace: "Coupon" })
  setCoupon: any;
  @Action("confirm", { namespace: "Coupon" })
  confirm: any;

  @Getter("hasData", { namespace: "Coupon" })
  hasData: boolean;
  @Getter("currentStateForShow", { namespace: "Coupon" })
  couponData: CouponData;
  @Getter("currentState", { namespace: "Coupon" })
  couponDataForSave: CouponData;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Getter("couponLoading", { namespace: "UserDataState" })
  isLoading: boolean;
  @Getter("couponError", { namespace: "UserDataState" })
  couponError: string;
  @Action("setError", { namespace: "UserDataState" })
  setError: any;

  @Getter("waitPartsSelect", { namespace: "SubHeader" })
  waitPartsSelect: boolean;

  @Action("updateSubTotal", { namespace: "Coupon" })
  updateSubTotal: any;

  /** 2021-05-31 sh #7126 fix add manual input [START] */
  @Getter("isConfirm", { namespace: "Coupon" })
  isConfirmCoupon: any;
  /** 2021-05-31 sh #7126 fix add manual input [END] */

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */

  couponLimitZn: number = 0;
  msgExceed: string = "割引/クーポンの上限金額を超えています。";
  isPopupExceed: boolean = false;

  get isError() {
    return this.couponError != "";
  }

  oncloseError() {
    this.setError({ key: "coupon", value: "" });
  }

  created() {
    if (window.sessionStorage.getItem("couponEditMode")) {
      this.isEditPrice = true;
      window.sessionStorage.removeItem("couponEditMode");
    }
    this.getCoupon();
    this.reqService
      .getCouponLimit(
        localStorage.getItem("groupCd"),
        localStorage.getItem("shatenCd"),
        localStorage.getItem("kyotenCd")
      )
      .then((res: any) => {
        if (res) {
          this.couponLimitZn = res.couponLimitZn;
          const limit = util.getNumberThousandSeparate(this.couponLimitZn);
        }
      });
  }

  mounted() {
    // if (this.$refs.sideTab) {
    //  this.$refs.sideTab.onActive(1);
    // }
    this.$emit("onActiveSideTab", 1);
  }

  getCoupon() {
    this.reqService = new requestService();

    if (!this.hasData && !this.isLoading) {
      const userService = new UserService();
      userService.getAllData();
      setTimeout(() => {
        this.onCheckChange();
      }, 750);
      //get data from api
      // this.reqService
      //   .getCoupon(this.uketsukeExtendsId)
      //   .then((response: any) => {
      //     if (response && response.coupon && response.proposal) {
      //       this.setCoupon(response);
      //       this.$set(this, "couponData", { ...response });
      //       this.mapIsCheck();
      //     }
      //   });
    } else {
      this.onCheckChange();
    }
  }

  // onConfirm() {
  //   this.$refs.confirmDialog.onOpen();
  // }

  onConfirm(isConfirm: number) {
    if (this.couponData) {
      if (this.couponData.coupon && this.couponData.coupon.items) {
        this.couponData.coupon.subTotalZk = this.subTotalZk;
        this.couponData.coupon.subTotalZn = this.subTotalZn;
      }
      this.setCoupon(this.couponData);
      let _isConfirm: any = isConfirm;
      if (isConfirm == 0) {
        _isConfirm = this.couponData.isConfirm;
      }
      if (
        this.couponDataForSave.coupon &&
        this.couponDataForSave.proposal &&
        this.couponDataForSave.tokuten
      ) {
        this.$set(this, "updating", true);
        const savePromise = this.reqService
          .saveCoupon({
            coupons: this.couponDataForSave.coupon.items,
            proposals: this.couponDataForSave.proposal.items,
            tokutens: this.couponDataForSave.tokuten.items,
            sknUketsukeUserJouhou: {
              isConfirmCoupon: _isConfirm
            },
            sknUketsukeExtendsId: this.uketsukeExtendsId
          })
          .then(
            (res: any) => {
              this.$set(this, "updating", false);
              if (isConfirm == 1) {
                if (this.waitPartsSelect) {
                  this.$refs.waitmd15Dialog.onOpen();
                } else {
                this.$router.push({ name: "userlegal56" });
              }
              /** 2021-06-01 sh #7123 if change checkbox, it gets flag from server. [START] */
              // this.confirm(_isConfirm);
              // this.$emit("onUserConfirm");
              this.$emit("onUserConfirmSync");
              /** 2021-06-01 sh #7123 if change checkbox, it gets flag from server. [END] */
            }
            },
            error => {
              this.$set(this, "updating", false);
              this.$notify.error({
                title: "エラー",
                message: MESSAGE.SystemError
              });
            }
          );
        // 保存処理中に赤画面の右サイドバーを無効化するため、親画面にPromiseを渡す
        // FIXME: 直観的でないので改善したい。
        //        単純に「保存処理の前後にemit」だと、右サイドバークリックイベントの場合に処理中に別のページに切り替わり、処理後のemitが親画面に届かずボタンが無効のままとなった。
        this.$emit("onOptionCouponUpdating", savePromise);

      } else {
        this.confirm(_isConfirm);
        this.$emit("onUserConfirm");
      }
    } else {
      if (isConfirm == 1) {
        if (this.waitPartsSelect) {
          this.$refs.waitmd15Dialog.onOpen();
        } else {
          this.$router.push({ name: "userlegal56" });
        }
      }
    }
  }

  onSave() {
    this.onConfirm(0);
  }

  calcTotal() {
    let tempSubTotalZk: number = 0;
    let tempSubTotalZn: number = 0;
    if (this.couponData.coupon && this.couponData.coupon.items) {
      this.couponData.coupon.items.filter(data => {
        if (data.isCheck == 1) {
          tempSubTotalZk += data.couponZk ? data.couponZk : 0;
          tempSubTotalZn += data.couponZn ? data.couponZn : 0;
        }
      });
      this.subTotalZk = tempSubTotalZk;
      this.subTotalZn = tempSubTotalZn;
    }
  }

  onCheck(value: any, item: any) {
    item.isCheck = value ? 1 : 0;
  }

  gotoCustomer() {
    this.$router.push({
      name: "usercustomer",
      params: { code: this.yoyakuNo }
    });
  }

  onCheckChange(coupon?: any) {
    this.calcTotal();
    this.updateSubTotal({
      subTotalZk: this.subTotalZk,
      subTotalZn: this.subTotalZn
    });

    if (coupon && coupon.isCheck && !this.isPopupExceed) {
      if (this.couponLimitZn) {
        if (Math.abs(this.subTotalZn) > Math.abs(this.couponLimitZn)) {
          this.$refs.exceedDialog.onOpen();
          this.isPopupExceed = true;
        }
      }
    }
  }

  onChangeCouponZk(coupon: any) {
    if (coupon.couponZk > 0) {
      coupon.couponZk = coupon.couponZk * -1;
    }
  }

  onChangeCouponZn(coupon: any) {
    if (coupon.couponZn > 0) {
      coupon.couponZn = coupon.couponZn * -1;
    }
  }

  focusNext(index: number) {
    if (this.$refs.inputKingaku[index + 1]) {
      this.$refs.inputKingaku[index + 1].focus();
    }
  }

  beforeDestroy() {
    if (this.isEditPrice) {
      window.sessionStorage.setItem("couponEditMode", "1");
    } else {
      window.sessionStorage.removeItem("couponEditMode");
    }
  }

  onOKWaitmd15Dialog() {
    this.$router.push({ name: "statusresult" });
  }

  onClickEdit(isEdit: boolean) {
    this.isEditPrice = isEdit;
    if (!this.isEditPrice) {
      this.onConfirm(0);
    }
  }

  onChangeKingaku() {
    /** 2023-10-26 invoice [Start] */
    if (this.couponZn && this.couponZn > 0) {
      this.couponZn = this.couponZn * -1;
    }
    /** 2023-10-26 invoice [End] */
    if (this.couponZk && this.couponZk > 0) {
      this.couponZk = this.couponZk * -1;
    }
  }
  addWork() {
    if (this.couponNm) {
      let item: CouponItem = {
        num: 0
        , couponNm: this.couponNm
        , couponZk: this.couponZk ? this.couponZk: 0
        /** 2023-10-26 invoice [START] */
        , couponZn: this.couponZn ? this.couponZn: 0
        /** 2023-10-26 invoice [END] */
        , isCheck: 0
      }
      if (this.couponData) {
        if (this.couponData.coupon) {
          if (this.couponData.coupon.items) {
            item.num = this.couponData.coupon.items.length + 1;
            this.couponData.coupon.items.push(item);
          } else {
            let items = [];
            items.push(item);
            this.couponData.coupon.items = items;
          }
        } else {
            let items = [];
            items.push(item);
            let coupon = {
              items: items
            };
          this.couponData.coupon = coupon;
        }
      } else {
        let items = [];
        items.push(item);
        let coupon = {
          items: items
        };
        this.couponData = {
          coupon: coupon
        };
      }
      this.couponNm = "";
      this.couponZk = null;
      /** 2023-10-26 invoice [START] */
      this.couponZn = null;
      /** 2023-10-26 invoice [END] */
    }
  }

  /** 2021-05-31 sh #7126 fix add manual input [START] */
  onChangeCoupon(coupon?: any) {
    /** 一度確認を押した後、内容が変更になったら、未にする */
    if (this.isConfirmCoupon == 1) {
      const couponCurrent = JSON.stringify(this.couponDataForSave.coupon);
      const couponOld = JSON.stringify(this.couponDataForSave.couponOld);
      if (couponCurrent != couponOld) {
        this.confirm(0);
        this.$emit("onUserConfirm");
      }
    }
    this.onCheckChange();
  }

  get checkManualCoupon() {
  	/** 2023-10-26 invoice [Start] */
    if (this.couponNm && ( this.couponZn || this.couponZk ) ) {
    /** 2023-10-26 invoice [End] */
      return false;
    }
    return true;
  }
  /** 2021-05-31 sh #7126 fix add manual input [END] */
}
